import type { ReactElement } from 'react';
import type { NextPage } from 'next';
import LayoutSelector from './layout-selector';

// Per-page layouts, best way to persist state between pages without
// mounting a whole provider in app.tsx
// https://nextjs.org/docs/pages/building-your-application/routing/pages-and-layouts#per-page-layouts
export type PageLayout = (page: ReactElement, pageProps: any) => ReactElement;

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: PageLayout;
};

// The default for pages that don't opt in
export const withLayoutSelector: PageLayout = (page, pageProps) => (
  <LayoutSelector pageProps={pageProps}>{page}</LayoutSelector>
);
